import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Theme } from "../../data/style/Theme";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  background: Theme.palette.card,
  p: 1,
  borderRadius: "12px",
  outline: "none",
};

const ModalPanel = (props) => {
  let { active, setActive, children } = props;

  const handleClose = () => setActive(false);
  return (
    <Modal
      sx={{ background: "rgba(48,152,213,0.1)" }}
      open={active}
      onClose={handleClose}
    >
      <Box sx={ModalStyle}>{children}</Box>
    </Modal>
  );
};

export default ModalPanel;
